<template>
  <div class="content-actions comment-options">
    <icon-button
      type="button"
      class="-ico-only -no-container -menu-opener"
      icon="more_vert"
      :label="isMenuOpen ? 'Action Menu Expanded' : 'Action Menu Collapsed'"
      :aria-expanded="isMenuOpen ? 'true' : 'false'"
      :aria-controls="menuId"
      @click-action="handleMenuOpen"
    />
    <outside-click :disabled="!isMenuOpen" @outside-click-action="handleMenuClose">
      <div
        :id="menuId"
        class="content-actions-group"
        :class="{ '-open': isMenuOpen }"
        :inert="!isMenuOpen"
      >
        <div class="content-actions-close">
          <icon-button
            type="button"
            class="-ico-only -no-container"
            icon="close"
            label="Close Menu"
            @click-action="handleMenuClose"
          />
        </div>
        <ul class="content-actions-list">
          <li class="content-action">
            <button class="btn" type="button" @click="handleEditComment">
              <i class="material-symbols-outlined" aria-hidden="true">edit</i>
              Edit Comment
            </button>
          </li>
          <li class="content-action">
            <button class="btn" type="button" @click="handleDeleteComment">
              <i class="material-symbols-outlined" aria-hidden="true">delete</i>
              Delete Comment
            </button>
          </li>
        </ul>
      </div>
    </outside-click>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import OutsideClick from '@/components/tool-tips/outside-click.vue'
import IconButton from '@/components/buttons/icon-button.vue'

/** PROPS */
const props = withDefaults(
  defineProps<{
    commentId: number
  }>(),
  {},
)

/** EMITS **/
const emit = defineEmits(['edit-comment', 'delete-comment'])

/** STATE */
const isMenuOpen = ref(false)

/** COMPUTED */
const menuId = computed(() => `comment-actions-menu-${props.commentId}`)

/** METHODS */
function handleMenuOpen() {
  isMenuOpen.value = true
}

function handleMenuClose() {
  isMenuOpen.value = false
}

function handleEditComment() {
  handleMenuClose()
  emit('edit-comment')
}

function handleDeleteComment() {
  handleMenuClose()
  emit('delete-comment')
}
</script>
